'use strict';

const processInclude = require('base/util');

require('base/components/spinner');

$(() => {
    processInclude(require('./delivery/delivery'));
});
